import consumer from "./consumer"

// This channel is subscribed to programmatically when needed
// See CodeGenerationStreamClient in page_containers/edit.html.erb
export default consumer;

